import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';

import './styles/ReviewDecisionCell.scss';

const ReviewDecisionCell = ({
  className,
  decisions,
  contact,
  initialSelected,
  onChange
}) => {
  const [editing, setEditing] = useState(false);
  const [selected, setSelected] = useState(initialSelected);

  const options = [
    'None',
    ...decisions
  ];

  const onSelect = e => {
    setSelected(options.find(option => option === e.target.value));
    onChange(contact, e.target.value);
  };

  return (
    <td className={classNames('review-decision-cell', className)}>
      {editing ? (
        <Form.Select
          ref={ref => ref && ref.focus()}
          className='review-decision-cell__select'
          size='sm'
          onChange={onSelect}
          onBlur={() => setEditing(false)}
          value={selected}
        >
          {options.map(option => (
            <option
              className={`review-decision-cell__option ${option}`}
              key={option}
              value={option}
            >
              {option}
            </option>
          ))}
        </Form.Select>
      ) : (
        <Button
          className={`review-decision-cell__field ${selected === 'None' ? 'empty' : ''}`}
          variant='link'
          onClick={() => setEditing(true)}
        >
          {selected}
        </Button>
      )}
    </td>
  );
};

ReviewDecisionCell.propTypes = {
  /** className prop */
  className: PropTypes.string,

  /** Select Options */
  decisions: PropTypes.arrayOf(
    PropTypes.string
  ),

  /** current contact */
  contact: PropTypes.shape({
    id: PropTypes.string
  }),

  /** Selected Option */
  initialSelected: PropTypes.string,

  /** OnChange callback */
  onChange: PropTypes.func
};

ReviewDecisionCell.defaultProps = {
  className: '',
  decisions: [],
  contact: {},
  initialSelected: {},
  onChange: () => false
};

export default ReviewDecisionCell;
